export default "__VITE_ASSET__70da5bed__"